import { AnyDoc } from "@megaron/docs-contracts";

const invoiceDraftEmptyNameFallback = "Wersja robocza";

const isInvoiceDraftDoc = (doc: AnyDoc): boolean => doc.docId.startsWith("invoice-draft:");

export const withInvoiceDraftNameFallback = (name: string, isInvoiceDraft: boolean): string => {
  if (isInvoiceDraft && name.trim().length === 0) {
    return invoiceDraftEmptyNameFallback;
  }

  return name;
};

export const getDocDisplayName = (doc: AnyDoc): string =>
  withInvoiceDraftNameFallback(doc.name ?? "", isInvoiceDraftDoc(doc));
